import { render } from "./physiotherapy_procedures.vue?vue&type=template&id=21942b00&scoped=true"
import script from "./physiotherapy_procedures.vue?vue&type=script&lang=js"
export * from "./physiotherapy_procedures.vue?vue&type=script&lang=js"

import "./physiotherapy_procedures.vue?vue&type=style&index=0&id=21942b00&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21942b00"]])

export default __exports__